import moduleObjects from './objects';

export default {
  namespaced: true,
  modules: {
    objects: moduleObjects,
  },
};
